export enum RestEndpoints {
  // Auth
  Login = "/v1/auth/login",
  LoginAsUser = "/v1/auth/login-as/:email",
  LogoutAsUser = "/v1/auth/logout-as",
  Logout = "/v1/auth/logout",
  Session = "/v1/auth/session",

  // User
  AllUsers = "/v1/users",
  GetUserInfo = "/v1/users/me",

  // Shared endpoints
  GroupForDetailView = "/v1/groups/:erpNumber/details",
  UsersForGroup = "/v1/groups/:erpNumber/users",
  GroupsLean = "/v1/groups",
  ContractsForGroup = "/v1/groups/:erpNumber/contracts",
  Config = "/v1/config",

  // POM endpoints
  PomAgencyGroups = "/v1/pom/agencies/:erpNumber",
  PomMainContactsOfCurrentGroup = "/v1/pom/groups/current/main-contacts",
  PomReportings = "/v1/pom/reportings",
  PomReportingDrafts = "/v1/pom/reporting-drafts",
}

export const replaceUriParameter = (uri: string, key: string, value: string | number): string => {
  return uri.replace(`:${key}`, value.toString());
};
